import { useTranslation } from "react-i18next";
import { getNameByLocation, isEmpty } from "../../../../utils/utils";

export default function BenchmarkRow({ benchmark, statistics }) {
  const { i18n } = useTranslation();

  if (benchmark === undefined || benchmark === "") {
    return null;
  }
  return (
    <tr className="family-table-row family-table-row-gray">
      <td style={{ padding: "5px" }}>
        <a
          href={benchmark.url}
          className="family-table-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {getNameByLocation(benchmark, i18n)}
        </a>
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics) ? "-" : (statistics["1_day"] * 100).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics)
          ? "-"
          : (statistics.beginning_of_year * 100).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics) ? "-" : (statistics["1y"] * 100).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics) ? "-" : (statistics["3y"] * 100).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics) ? "-" : (statistics["5y"] * 100).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics) ? "-" : (statistics["10y"] * 100).toFixed(2)}
      </td>
      <td dir="ltr" className="family-table-cell">
        {isEmpty(statistics) ? "-" : (statistics["15y"] * 100).toFixed(2)}
      </td>
    </tr>
  );
}
